import React from "react";
import AdminLayout from "./AdminLayout";
import { Box, Typography } from "@mui/material";

const SettingsPage = () => {
  return (
    <AdminLayout>
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="h5" sx={{ color: "#1a1a1a" }}>
          Settings
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          System settings interface will be implemented here.
        </Typography>
      </Box>
    </AdminLayout>
  );
};

export default SettingsPage;
